'use client'

import { useMemo } from 'react'

import { FeatureFlagsDocument } from '@features/flags.graphql'
import { FeatureFlagsContext } from '@features/flags.hooks/useFeatureFlags'
import { useQuery } from '@shared/apollo'

/**
 * Poll interval for feature flags in milliseconds.
 * Feature flags are re-fetched every 60 seconds.
 */
const FEATURE_FLAGS_POLL_INTERVAL = 60_000

export interface FeatureFlagsProviderProps {
  /**
   * Children of the provider.
   */
  children: React.ReactNode
}

export const FeatureFlagsProvider: React.FC<FeatureFlagsProviderProps> = ({
  children,
}) => {
  const { data, ...rest } = useQuery(FeatureFlagsDocument, {
    pollInterval: FEATURE_FLAGS_POLL_INTERVAL,
  })

  const contextValue = useMemo(
    () => ({
      featureFlags: data?.featureFlags,
      ...rest,
    }),
    [data?.featureFlags, rest],
  )

  return (
    <FeatureFlagsContext.Provider value={contextValue}>
      {children}
    </FeatureFlagsContext.Provider>
  )
}
